<template>
	<el-tabs>
		<el-tab-pane >
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>	
			<div class="zidingyi_pd">
				<div v-for="(l,i) in value.shu"  style="position: relative;" class="zidingyi_sc">
					<div class="zidingyi_shanchu" @click.stop="Shanchu(i)"><i class="el-icon-circle-close"></i></div>
					
					<Biaodan v-model="value.shu[i]" :ming='"lunbo"+i'></Biaodan>
				</div>
			</div>
			
			<el-button type="primary"  size="mini"  @click="Jia" style="margin-left: 20px;">+新增</el-button>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<!-- <el-input placeholder="请输入内容" v-model="value.yangshi.gao">
				<template slot="prepend">Http://</template>
			</el-input> -->
		</el-tab-pane>
	</el-tabs>
</template>
 
<script>
	
	import Biaodan from '../Biaodan.vue'
	export default {
		name: 'lunbo_bianji',
		data(){
			return {
				
			}
		},
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},
		components: {
			Biaodan
		},	
		methods: {
				Jia() {
					this.value.shu.push({
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/pMVvuzinpnD1pNIfPnLOMHh0NVCLnl.jpg',
						ming: '名称'
					})
				},
				Shanchu(e) {
					this.value.shu.splice(e, 1);
				}
			}

	}
</script>
<link rel="stylesheet" href="Yangshi.css">
